import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ZoneService from 'src/_services/ZoneService';
import { API_LOADING_STATUSES } from 'src/constants';

const initialState = {
  list: [],
  zoneDetails: {},
  loading: false,
  status: API_LOADING_STATUSES.idle,
  error: null,
}

export const fetchZones = createAsyncThunk('zones/fetchZones', async _ => {
  const response = await ZoneService.getZones();
  return response.data.body
})

const zonesSlice = createSlice({
  name: "zones",
  initialState,
  reducers: {
    clearZones: (zones, action) => {
      zones.list = [];
      zones.loading = false;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchZones.pending, (state, action) => {
        state.status = API_LOADING_STATUSES.loading
      })
      .addCase(fetchZones.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
        state.status = API_LOADING_STATUSES.succeeded
        state.error = null
      })
      .addCase(fetchZones.rejected, (state, action) => {
        state.loading = false;
        state.status = API_LOADING_STATUSES.failed
        state.error = action.error.message
      })
  }
});

export const { clearZones } = zonesSlice.actions

export default zonesSlice.reducer
